export enum SocialMetricGroupingEnum {
  Daily = 1,
  Mounthly = 2,
  Months3 = 3
}